import MainFrame from "@/Layout/Layout";

import slide2 from "@images/slider/slide-2.jpg";
import { SimplifiedContactForm } from "@pages/contact/ContactUsView";
import IndividualPPReviewer from "@pages/portfolio/components/IndividualPPreviewer";

const IndividualProductView = () => {
  return (
    <MainFrame>
      <div className={`w-full`}>
        <IndividualPPReviewer />
      </div>
      <SimplifiedContactForm />
    </MainFrame>
  );
};

export default IndividualProductView;
